import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import CategorySection from './components/CategorySection';
import ComparisonSection from './components/ComparisonSection';
import GuideSection from './components/GuideSection';
import SafetySection from './components/SafetySection';
import LatestArticlesSection from './components/LatestArticlesSection';
import FaqSection from './components/FaqSection';
import FinalCtaSection from './components/FinalCtaSection';
import { SITE_URL } from '@/utils/siteUrl';

export default function Home() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Pandabuy.autos',
    url: SITE_URL,
    description: 'Best Pandabuy Spreadsheet 2026 with updated daily finds, verified sellers, and complete buying guides.',
    logo: `${SITE_URL}favicon.ico`,
    sameAs: [
      'https://kaspreadsheet.com',
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: SITE_URL,
      },
    ],
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Pandabuy.autos',
    url: SITE_URL,
    description: 'Best Pandabuy Spreadsheet 2026 with updated daily finds, verified sellers, and complete buying guides.',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webSiteSchema)}</script>

      <Navbar />

      <main>
        <HeroSection />

        <TrustSection />

        <CategorySection />

        <ComparisonSection />

        <GuideSection />

        <SafetySection />

        <LatestArticlesSection />

        <FaqSection />

        <FinalCtaSection />
      </main>

      <Footer />
    </>
  );
}